/**
 * Wartości współdzielone z backendem. Trzymane osobno, bo import z `@veycue/auth`
 * ściągnąłby do bundla przeglądarki cały moduł kryptograficzny — a potrzebna jest
 * jedna liczba do walidacji formularza (rzeczywistą politykę egzekwuje API).
 */
export const PASSWORD_MIN_LENGTH = 10;
